import context, { Coordinate, IGeocoder, GeocodeResult } from '@truckdown/systems';
import { Listing, ListingTemplate, PreferenceType, SearchRequestBase } from '@truckdown/locations';

const iconPrefix = '/listings/locations-components/img/mappin-';
const iconSuffix = '.png';
const customClasses = ['msp', 'mspar', 'border', 'bruckners'];

const getIconPreference = function (listing: Listing) {
    if (listing.properties.preference?.type == PreferenceType.Preferred) {
        return '-p';
    } else {
        return '';
    }
}

const getIconName = function (listing: Listing) {
    if (listing.properties.useCustomPin) {
        if (customClasses.some((c) => c == listing.properties.customClass)) {
            if (listing.properties.customClass == 'mspar') {
                return 'msp';
            }

            return listing.properties.customClass;
        }
    }

    switch (listing.properties.template) {
        case ListingTemplate.TDPreferred:
            return 'preferred';
        case ListingTemplate.Elite:
            return 'elite';
        case ListingTemplate.Pro:
            return 'pro';
        case ListingTemplate.Branded:
            return 'default';
        default:
            return 'default';
    }
}

const getServiceUrlPortion = function (request: SearchRequestBase): string {
    let sections = window.location.pathname.split('/');
    if (sections.length >= 4 && sections[3].length > 0) {
        return '/' + sections[3];
    }
    return '/services';
}

const getServicesQuery = function (request: SearchRequestBase): string {
    return '?svs=' + request.services.join('-');
}

const getCountryCode = function (code?: string): string | undefined {
    if (code && code.length == 3) {
        if (code == 'CAN') {
            return 'CA';
        }
        if (code == 'USA') {
            return 'US';
        }
        if (code == 'MEX') {
            return 'MX';
        }
    } else if (code?.toLowerCase() == 'us' || code?.toLowerCase() == 'ca' || code?.toLowerCase() == 'mx') {
        return code;
    }
    return undefined;
}

const getLocationQuery = function (request: SearchRequestBase, coord: Coordinate, res?: GeocodeResult): string {
    return '&lat=' + coord.lat
        + '&lng=' + coord.lng
        + '&ctryCd=' + (getCountryCode(res?.address.countryCode) ?? request.meta['CountryCode'])
        + '&rgnCd=' + (res?.address.stateCode ?? request.meta['RegionCode']);
}

const getAmentityQuery = function (request: SearchRequestBase): string {
    if (request.filters.length > 0) {
        return '&ams=' + request.filters.join('-');
    }
    return '';
}

const getOptionsQuery = function (request: SearchRequestBase): string {
    return (request.options.searchByDistance ? '&sod=true' : '')
        + (request.options.suppressManagedServices ? '&sms=true' : '')
        + '&om=true';
}

const getUrl = function (request: SearchRequestBase, coord: Coordinate, res?: GeocodeResult): string {
    return '/search/results'
        + getServiceUrlPortion(request)
        + '/Coordinates'
        + getServicesQuery(request)
        + getLocationQuery(request, coord, res)
        + getAmentityQuery(request)
        + getOptionsQuery(request);
}

const utilities = {
    getIcon: function (listing: Listing, isSelected: boolean): string {
        return iconPrefix + getIconName(listing)
            + getIconPreference(listing) + (isSelected ? '-sel' : '') + iconSuffix;
    },
    getSearchUrl: async function (request: SearchRequestBase, coords: Coordinate) {
        try {
            let geocoder = await context.getService<IGeocoder>('IGeocoder');
            let res = await geocoder.geocode(coords);
            if (res.length > 0) {
                return getUrl(request, coords, res[0]);
            } else {
                return getUrl(request, coords);
            }
        }
        catch (err) {
            console.log(err);
            return getUrl(request, coords);
        }
    }
};

export const LocationUtilities = utilities;